/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Improve_Sleep_WhyInputs */

const en_us2_improve_sleep_why = /** @type {(inputs: Improve_Sleep_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muscle is built while you sleep. Short sleep means a lighter plan, not a failed one.`)
};

const pt_br2_improve_sleep_why = /** @type {(inputs: Improve_Sleep_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O músculo cresce enquanto você dorme. Sono curto significa plano mais leve, não fracasso.`)
};

const es_419_improve_sleep_why = /** @type {(inputs: Improve_Sleep_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El músculo crece mientras duermes. Dormir poco significa un plan más ligero, no un fracaso.`)
};

const pt_pt2_improve_sleep_why = /** @type {(inputs: Improve_Sleep_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O músculo cresce enquanto dormes. Dormir pouco significa um plano mais leve, não um fracasso.`)
};

const fr_fr2_improve_sleep_why = /** @type {(inputs: Improve_Sleep_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le muscle se construit pendant le sommeil. Peu de sommeil, c'est un programme plus léger, pas un échec.`)
};

const de_de2_improve_sleep_why = /** @type {(inputs: Improve_Sleep_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muskeln wachsen, während du schläfst. Wenig Schlaf heißt ein leichterer Plan, kein gescheiterter.`)
};

const it_it2_improve_sleep_why = /** @type {(inputs: Improve_Sleep_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il muscolo si costruisce mentre dormi. Dormire poco significa una scheda più leggera, non un fallimento.`)
};

/**
* | output |
* | --- |
* | "Muscle is built while you sleep. Short sleep means a lighter plan, not a failed one." |
*
* @param {Improve_Sleep_WhyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const improve_sleep_why = /** @type {((inputs?: Improve_Sleep_WhyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Improve_Sleep_WhyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_improve_sleep_why(inputs)
	if (locale === "es-419") return es_419_improve_sleep_why(inputs)
	if (locale === "pt-PT") return pt_pt2_improve_sleep_why(inputs)
	if (locale === "fr-FR") return fr_fr2_improve_sleep_why(inputs)
	if (locale === "de-DE") return de_de2_improve_sleep_why(inputs)
	if (locale === "it-IT") return it_it2_improve_sleep_why(inputs)
	return en_us2_improve_sleep_why(inputs)
});
export { improve_sleep_why as "improve.sleep.why" }